export default [
  {
    path: '/modules/report',
    redirect: '/modules/report/attendance',
    name: 'reportPageAttendance',
    component: () => import('@/views/modules/report/Report.vue'),
    meta: {
      action: 'ROLE_RELATORIO_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Relatórios',
      breadcrumb: [
        {
          text: 'attendance',
        },
      ],
    },
    children: [
      {
        path: 'attendance',
        name: 'attendance',
        component: () => import('@/views/modules/report/Report.vue'),
        meta: {
          pageTitle: 'Relatórios',
          action: 'ROLE_RELATORIO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Atendimento | Relatórios',
            },
          ],
        },
      },
    ],
  },
]
